import { useState } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { useLesson } from "../../services/lessons/lessons.context";
import { AppFooter } from "../../components/footer/footer";
import { AppAlert } from "../../components/utilities/app-alert";
import { homeFeatures } from "../../_helpers/mock-data";
import "../../styles/home.css";
import { HomePic } from "../../components/home/home-pic";
import { FeatureList } from "../../components/home/faeture-list";
import { CourseUnit } from "../../components/home/course-unit";


export const HomePage = () => {

    const { isLoading, isAuthenticated, user } = useAuth();

    const { courses } = useLesson();

    const navigateTo = useNavigate();

   
    const [onAlert, setOnAlert] = useState();

    // useEffect(() => {
    //     (async () => {
    //         const data = await getAllCourses();
    //         setCourses(data);
    //     })();
    // }, [])



    return (
        <div className="min-v">
            <AppHeader />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAccept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <HomePic navigate={() => navigateTo("/lessons")} />
            <div className="page-cap">Core features</div>
            <FeatureList list={homeFeatures} />
            <div className="page-cap">Latest Course</div>
            {courses?.length > 0 ?
                <>
                    <CourseUnit
                        handleClick={() => {
                            if (!isAuthenticated) {
                                setOnAlert({
                                    caption: "Unauthorized!",
                                    message: "Please login to access the content of this course",
                                    accept: "OK",
                                    reject: "Cancel",
                                    onAccept: () => navigateTo("/login"),
                                    onReject: () => setOnAlert()
                                });
                                return;
                            }
                            if (user?.role === "user" && !user?.placed){
                               navigateTo("/placement");
                               return;
                            }
                            navigateTo("/course", { state: { course: courses[0] } })
                        }}
                        course={courses[0]}
                    />
                    <div className={classNames("flx-c-rw", 'v-3', 'pad-3')}>
                        <button
                            className="start-button"
                            onClick={() => { navigateTo("/courses") }}
                        >
                            More courses
                        </button>
                    </div>
                </>
                :
                <div className="page-cap">No courses available for now</div>
            }
            <AppFooter />
        </div>
    )
}